export default __webpack_public_path__ + "static/media/churchill.b53c316a.png";